import { useEffect, useState } from 'react';
import { Button, Card, Col, Row, Typography, Modal, Space } from 'antd';
import { PlusOutlined, SyncOutlined, SettingOutlined } from '@ant-design/icons';
import axiosInstance from '../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';

const { Title, Text } = Typography;

const Journaux = () => {
    const [modalEvent, setModalEvent] = useState(null);
    const [nom, setNom] = useState('');
    const [commentaire, setCommentaire] = useState('');
    const [code, setCode] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [journaux, setJournaux] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [journal, setJournal] = useState("");

    const handleAdd = () => {
        setLoading(true);
        // Logic to add a new event
        if (editMode) {
            journal.intitule = nom;
            journal.description = commentaire;
            journal.code = code;
            axiosInstance.put('/api/journal-comptable', journal)
                .then((res) => {
                    console.log("Event added successfully:", res.data);
                    toast.success("Journal modifiée avec succès !");
                    // Optionally, refresh the tree data or update state to reflect the new event
                    handleCancel();
                    setLoading(false);
                })
                .catch((err) => {
                    console.error("Error adding event:", err);
                    setLoading(false);
                });

        } else {
            axiosInstance.post('/api/journal-comptable', {
                intitule: nom,
                description: commentaire,
                code: code
            })
                .then((res) => {
                    console.log("Event added successfully:", res.data);
                    setJournaux([...journaux, res.data]);
                    toast.success("Journal ajouté avec succès !");
                    // Optionally, refresh the tree data or update state to reflect the new event
                    handleCancel();
                    setLoading(false);
                })
                .catch((err) => {
                    console.error("Error adding event:", err);
                    setLoading(false);
                });
        }

    }

    useEffect(() => {
        axiosInstance.get('/api/journal-comptable')
            .then((res) => {
                console.log("Events fetched successfully:", res.data);
                setJournaux(res.data);
            })
            .catch((err) => {
                console.error("Error fetching events:", err);
            });
    }, []);

    const handleCancel = () => {
        setOpenModal(false);
        setNom('');
        setCommentaire('');
        setCode('');
        setEditMode(false);
    };

    return (
        <div style={{ padding: '24px' }}>
            <Card style={{ borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.09)' }}>
                <Row justify="space-between" align="middle" style={{ marginBottom: '24px' }}>
                    <Title level={4} style={{ margin: 0 }}>Journaux</Title>
                    <Space size="middle">
                        <Button
                            style={{ backgroundColor: '#1890ff', borderColor: '#1890ff' }}
                            onClick={() => setOpenModal(true)}
                            type="primary"
                            icon={<PlusOutlined />}
                        >
                            Nouveau journal
                        </Button>
                        {/* <Button icon={<SyncOutlined />}>Actualiser</Button> */}
                    </Space>
                </Row>

                <Row gutter={[16, 16]}>
                    {journaux.map((event, idx) => (
                        <Col xs={24} md={12} lg={8} key={idx}>
                            <Card
                                title={<Text className="text-blue-800">{event?.code}</Text>}
                                bordered
                            >
                                <p>
                                    <Text type="secondary">Libellé:</Text> <Text>{event?.intitule}</Text>
                                </p>
                                <p>
                                    <Text type="secondary">Description:</Text>
                                    <br />
                                    <Text>{event?.description}</Text>
                                </p>
                                <div className="flex justify-end mt-4">
                                    <Button
                                        type="link"
                                        icon={<SettingOutlined />}
                                        onClick={() => {
                                            setEditMode(true);
                                            setJournal(event);
                                            setOpenModal(true);
                                            setNom(event.intitule);
                                            setCommentaire(event.description);
                                            setCode(event.code);
                                            // setModalEvent(event);
                                        }}
                                    >
                                        Configurer
                                    </Button>
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Card>

            {/* Modal Config */}
            {modalEvent && (
                <Modal
                    title={`Configuration de ${modalEvent.title}`}
                    open={true}
                    onCancel={() => setModalEvent(null)}
                    footer={[
                        <Button key="cancel" onClick={() => setModalEvent(null)}>
                            Annuler
                        </Button>,
                        <Button key="submit" type="primary">
                            Enregistrer
                        </Button>,
                    ]}
                >
                    <p><strong>Intitulé:</strong> {modalEvent.module}</p>
                    <p><strong>Description:</strong> {modalEvent.description}</p>
                </Modal>
            )}

            <Modal
                title={editMode ? "Modifier le journal" : "Ajouter un journal"}
                open={openModal}
                onOk={handleAdd}
                onCancel={handleCancel}
                loading={loading}
                okText={editMode ? "Modifier" : "Ajouter"}
                cancelText="Annuler"
            >
                <div className="row">
                    <div className="col-8">
                        <div class="mb-3">
                            <label for="nom" class="form-label">Nom du journal</label>
                            <input type="text" class="form-control" placeholder="Nom du journal" id="nom" value={nom} onChange={(e) => setNom(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-4">
                        <div class="mb-3">
                            <label for="code" class="form-label">Code</label>
                            <input type="text" class="form-control" placeholder="Code" id="code" value={code} onChange={(e) => setCode(e.target.value)} />
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <label for="commentaire" class="form-label">Description</label>
                        <textarea
                            class="form-control"
                            id="commentaire"
                            placeholder="Description du journal"
                            value={commentaire}
                            onChange={(e) => setCommentaire(e.target.value)}
                        ></textarea>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default Journaux
